import React from 'react';
import Accordion from 'atoms/Accordion/Accordion';
import styles from './BoxListElement.module.scss';
function BoxListElement({ accordion, marker, header, children }) {
    if (accordion) {
        return (React.createElement("li", { className: styles.wrap },
            React.createElement(Accordion, { header: React.createElement("header", { className: styles.header },
                    marker && React.createElement("span", { className: styles.marker }, marker),
                    React.createElement("p", null, header)) },
                React.createElement("main", { className: styles.main }, children))));
    }
    return (React.createElement("li", { className: styles.wrap },
        React.createElement("header", { className: styles.header },
            marker && React.createElement("span", { className: styles.marker }, marker),
            React.createElement("p", null, header)),
        React.createElement("main", { className: styles.main }, children)));
}
export default BoxListElement;
